module.exports = __webpack_public_path__ + "img/ctrl-givens-stub-up-1.7acd03e5.svg";